import { API_ROOT } from '../../config/config'
import { doDelete, doDeleteBody, doGet, doPost } from './utils'

export const getWaitScrutinize = (pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/widget/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doGet(url)
}

export const searchWaitScrutinize = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/search/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const getProjectListSchemaPagination = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/select/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const getProjectListSchema = (request) => {
  const url = `${API_ROOT}/multiple/select/`
  return doPost(url, request)
}

//สร้าง review หลายโครงการ
export const createReviewGroup = (request) => {
  const url = `${API_ROOT}/multiple/createreviewgroup/`
  return doPost(url, request)
}

//แผนงบประมาณ
export const getPaymentPlanSchema = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/budget/page/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const getPaymentPlanData = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/budget/widget/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const savePaymentPlanMuti = (request) => {
  const url = `${API_ROOT}/multiple/budget/add`
  return doPost(url, request)
}

// บันทึกการเข้าประชุม
export const getAttendanceSchemaMulti = (request) => {
  const url = `${API_ROOT}/multiple/attendance/page`
  return doPost(url, request)
}

export const getAttendanceMulti = (request) => {
  const url = `${API_ROOT}/multiple/attendance/widget`
  return doPost(url, request)
}

export const updateAttendanceMulti = (request) => {
  const url = `${API_ROOT}/multiple/attendance/record`
  return doPost(url, request)
}

// ประว้ติกลั่นกรองหลายโครงการ)
export const getReviewHistorySchemaMulti = () => {
  const url = `${API_ROOT}/multiple/history/page`
  return doGet(url)
}

export const getReviewHistoryMulti = (pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/history/widget/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doGet(url)
}

export const deleteReviewHistoryMulti = (request) => {
  const url = `${API_ROOT}/multiple/history/delete`
  return doDeleteBody(url, request)
}

// อนุมัติผู้ทรงหลายโครงการ)
export const getMultiApproveReviewerList = (pagesize, pagenumber) => {
  const url = `${API_ROOT}/review/multi/approve-reviewer/widget/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doGet(url)
}

// ตรวจสอบงวดเงิน ยืนยันงบประมาณหลายโครงการ
export const getMultiProjectReviewPaymentCheckPage = (groupId) => {
  const url = `${API_ROOT}/approval/multi/review-payment-check/${groupId}/page`
  return doGet(url)
}

export const getMultiReviewPaymentCheckProjectList = (groupId, pagesize, pagenumber) => {
  const url = `${API_ROOT}/approval/multi/review-payment-check/${groupId}/data/pagenum/${pagenumber}/pagesize/${pagesize}`
  return doGet(url)
}

export const saveMultiReviewPaymentCheck = (request) => {
  const url = `${API_ROOT}/approval/multi/review-payment-check/${request.groupId}/save`
  return doPost(url, '')
}

// เสนอพิจราณาอนุมัติหลายโครงการ
export const GetMultiProjectConsiderApprovePage = (groupId) => {
  const url = `${API_ROOT}/approval/multi/consider-approve/${groupId}/page`
  return doGet(url)
}

export const GetMultiProjectConsiderApproveProjectList = (groupId, pagesize, pagenumber) => {
  const url = `${API_ROOT}/approval/multi/consider-approve/${groupId}/data/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doGet(url)
}

export const saveProposeConsiderApproveMultiProject = (groupId, request) => {
  const url = `${API_ROOT}/approval/multi/${groupId}/submit/proposal`
  return doPost(url, request)
}
